import React from 'react'

export default class Inicio extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div className="form-group row mt-3 text-left">
                    <label className="col-3 col-md-2">Data:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="date" className="form-control" 
                            name="data"
                            {...this.props}
                            value={this.props.value.data} />
                    </div>
                    <label className="col-3 col-md-2">Entrada:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="time" className="form-control" 
                            name="entrada"
                            {...this.props}
                            value={this.props.value.entrada} />
                    </div>
                    <label className="col-3 col-md-2">Saída:</label>
                    <div className="col-9 col-md-2 mb-3">
                        <input type="time" className="form-control" 
                            name="saida"
                            {...this.props}
                            value={this.props.value.saida} />
                    </div>
                </div>
            </React.Fragment>
        )
    }
}